module.exports = __webpack_public_path__ + "img/Mastercard_White.665bbb33.svg";